module.exports = __webpack_public_path__ + "static/media/a8.c87c60e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wangxingxing/a8.mp3
// module id = wYsL
// module chunks = 0